import { trackBulkOrderError } from "@DSG/Common/DSGTracking";
import ApplicationStateDSG from "@DSG/Store/DSGState";
import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchCompleteBatchLoadProducts } from "@insite/client-framework/Store/Components/OrderUpload/Handlers/BatchLoadProducts";


if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
addToChainBefore(chain, DispatchCompleteBatchLoadProducts, addBulkOrderErrorTracking);

// get the type of props using this
type TrackingParameters = Parameters<typeof DispatchCompleteBatchLoadProducts>[0];

async function addBulkOrderErrorTracking(props: TrackingParameters) {
    const customState = props.getState() as ApplicationStateDSG;
    
    trackBulkOrderError(props.result.rowErrors,customState);
}
